<script>
/**
 * Common mixin for management pages for teams selection
 */

// Vuex
import { mapState } from 'vuex';
import { FETCH_TEAMS} from '@/store/action-types';
import { GET_TEAMS} from '@/store/mutation-types';

export default {

  computed: {
    mgtPagesOptions() {
      return [
        {
          key: 'teams',
          component: 'AdvancedTeamPicker',
          value: this.mgtPagesOptTeams,
        },
      ];
    },
    mgtPagesOptTeams() {
      if (this.allPageOptions && this.allPageOptions.teams) {
        return this.allPageOptions.teams;
      }
      return [];
    },
    mgtPagesOptTeamsItems() {
      const teamsData = this.mgtPagesOptTeamsData;
      return [
        ...teamsData.map(team => ({ id: Number(team.id), label: team.name })),
      ];
    },
    ...mapState({
      mgtPagesOptTeamsData: state => state[GET_TEAMS.stateKey] || [],
      mgtPagesOptTeamsLoading: state => state[GET_TEAMS.loadingKey],
    }),
  },

  created() {
    // Fetch all display configs
    if (!this.mgtPagesOptTeamsLoading && this.currentTeam && this.currentTeam.id) {
      this.$store.dispatch(FETCH_TEAMS);
    }
  },

  methods: {
    mgtPagesOptQueryParams(options) {
      if (!options) {
        return '';
      }
      let query = '';
      let amp = '';
      if (options.teams && options.teams.length) {
        query += `${amp}mgtTeams=${options.teams}`;
        amp = '&';
      }
      return query;
    },
  },
};
</script>
